import { render, staticRenderFns } from "./imageUploader.vue?vue&type=template&id=bfcd6eee&"
import script from "./imageUploader.vue?vue&type=script&lang=js&"
export * from "./imageUploader.vue?vue&type=script&lang=js&"
import style0 from "./imageUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\2000HuiTian\\huitianadmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfcd6eee')) {
      api.createRecord('bfcd6eee', component.options)
    } else {
      api.reload('bfcd6eee', component.options)
    }
    module.hot.accept("./imageUploader.vue?vue&type=template&id=bfcd6eee&", function () {
      api.rerender('bfcd6eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/imageUploader.vue"
export default component.exports